import { useState, useEffect, useRef } from "react";
import shopnavicon2 from '../../../assets/images/power_card_box.webp'
import cardBack from '../../../assets/images/backCard.png'
import Spinner from 'react-bootstrap/Spinner';
import { client, session } from '../../../utils/nakama';
import Container from 'react-bootstrap/Container';
import bonezIcon from '../../../assets/images/bonez_icon.svg'
import './ShopNav.css';
import eventsCenter, { PHASER_EVENTS } from "../../../utils/phaserEvents";

export default function CardNav(props) {
    const [showButtons, setShowButtons] = useState(true);
    const [showSpinner, setShowSpinner] = useState(false);
    const [isFirst, setIsFirst] = useState(true);

    const { isCoinActive, toggleCoinContent } = props;
    const { isBonezActive, toggleBonezContent } = props;
    const { isBalanceUpdated, toggleBalanceUpdated } = props;

    const [card1, setCard1] = useState('back');
    const [card2, setCard2] = useState('back');
    const [card3, setCard3] = useState('back');
    const [card4, setCard4] = useState('back');
    const [card5, setCard5] = useState('back');

    // Vite replacement for require.context on public assets
    const cardImages = (path) => {
        // Remove ./ from the beginning if present
        const cleanPath = path.startsWith('./') ? path.substring(2) : path;
        return `/bonez/images/cards/${cleanPath}`;
    };

    const handleCoin = async () => {
        toggleBalanceUpdated();
        setShowButtons(false);
        setShowSpinner(true);
        try {
            const purchaseResultchipz = await client.rpc(session, "buyOpenBonezPack", { "type": "chipz" });
            if (purchaseResultchipz.payload.wallet.zoom < 10000) {
                toggleCoinContent();
            } else {
                // emit event to update balances
                eventsCenter.emit(PHASER_EVENTS.BUY_OPEN_PACK, purchaseResultchipz.payload);

                // Cancel match if wager is higher than wallet balance
                if (props.availableMatchesQuery.isSuccess) {
                    props.availableMatchesQuery.data.payload.availableMatches.forEach((match) => {
                        if (match.label.hostId === session.user_id &&
                            match.label.wagerType === "zoom" &&
                            match.label.potAmount / 2 > purchaseResultchipz.payload.wallet.zoom - 10000
                        ) {
                            console.log('Wallet balance lower than wager amount. Terminating match.');
                            props.leaveMatch(match.matchId);
                        }
                    });
                }
                setIsFirst(false);

                const audio = new Audio('/bonez/sounds/buy.mp3');
                audio.play();
                setTimeout(() => {
                    setShowSpinner(false);
                    setCard1(purchaseResultchipz.payload.selectedCards[0]);
                    setCard2(purchaseResultchipz.payload.selectedCards[1]);
                    setCard3(purchaseResultchipz.payload.selectedCards[2]);
                    setCard4(purchaseResultchipz.payload.selectedCards[3]);
                    setCard5(purchaseResultchipz.payload.selectedCards[4]);

                    setShowButtons(true);
                }, 500);
            }
        } catch (error) {
            console.error("CHIPZ ATTEMPT to buy and open card pack:", error);
        }
    };

    const handleBonez = async () => {
        const audio = new Audio('/bonez/sounds/buy.mp3');
        audio.play();

        if (props.userBones < 50) {
            toggleBonezContent();
            return;
        }

        toggleBalanceUpdated();
        setShowButtons(false);
        setShowSpinner(true);
        try {
            const purchaseResultbones = await client.rpc(session, "buyOpenBonezPack", { "type": "bones" });
            if (purchaseResultbones.payload.userLevel[0].value.data.bone < 50) {
                toggleBonezContent();
            }

            // emit event to update balances
            eventsCenter.emit(PHASER_EVENTS.BUY_OPEN_PACK, purchaseResultbones.payload);

            // Cancel match if wager is higher than wallet balance
            if (props.availableMatchesQuery.isSuccess) {
                props.availableMatchesQuery.data.payload.availableMatches.forEach((match) => {
                    if (match.label.hostId === session.user_id &&
                        match.label.wagerType === "bonez" &&
                        match.label.potAmount / 2 > purchaseResultbones.payload.userLevel[0].value.data.bone - 50
                    ) {
                        console.log('Wallet balance lower than wager amount. Terminating match.');
                        props.leaveMatch(match.matchId);
                    }
                });
            }

            setIsFirst(false);
            setTimeout(() => {
                setShowSpinner(false);
                setShowButtons(true);
                setCard1(purchaseResultbones.payload.selectedCards[0]);
                setCard2(purchaseResultbones.payload.selectedCards[1]);
                setCard3(purchaseResultbones.payload.selectedCards[2]);
                setCard4(purchaseResultbones.payload.selectedCards[3]);
                setCard5(purchaseResultbones.payload.selectedCards[4]);
                audio.play();
            }, 500);

        } catch (error) {
            console.error("ATTEMPT to buy and open card pack:", error);
        }
    }

    return (
        isFirst ? (
            <>
                <div className="card-pack-title" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <img className="shopicon4" alt="" src={shopnavicon2} />
                    <span className="container-body-text getcards" style={{ color: "#00D1FF" }}>GET CARDS</span>
                </div>
                <div className="backcards" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <img className="shopback" alt="" src={cardBack} style={{ marginLeft: '25%' }} />
                    <img className="shopback" alt="" src={cardBack} style={{ marginLeft: '10%' }} />
                </div>
                <div className="backcards2" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2%', marginBottom: '2%' }}>
                    <img className="shopback" alt="" src={cardBack} style={{ marginLeft: '10%' }} />
                    <img className="shopback" alt="" src={cardBack} style={{ marginLeft: '10%' }} />
                    <img className="shopback" alt="" src={cardBack} style={{ marginLeft: '10%' }} />
                </div>
                <span className="container-body-text powercards" style={{ color: "#00D1FF", marginLeft: '1rem' }}>POWER CARD</span>
                <span className="container-body-text pack" style={{ color: "#00D1FF", marginLeft: '1rem' }}>5 PACK</span>
                {showButtons && (
                    <Container style={{ display: "flex", justifyContent: "space-around" }}>
                        <button className="button" onClick={handleCoin} disabled={!showButtons} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
                            <img className="green-button-10000" src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" />

                            <span className="button-text" style={{ fontSize: "22px", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px", textAlign: "center" }}>
                                <img
                                    className="icon"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    style={{ width: "40%", height: "90%", marginRight: "5px", marginBottom: "7%", marginLeft: "-20px" }}
                                    alt="Chipz icon"
                                />
                                10,000
                            </span>
                        </button>

                        <button className="button" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }} onClick={handleBonez} disabled={!showButtons}>
                            <img className="green-button-10000" src="https://zoombies.world/images/dapp/purple_button_500.webp" alt="" />
                            <span className="button-text" style={{ fontSize: "22px", marginLeft: "5px", textAlign: "center" }}>
                                <img
                                    className="icon"
                                    title="Zoombies Chipz"
                                    src={bonezIcon}
                                    style={{ width: "50%", height: "auto", marginRight: "5px", marginLeft: "-20px", marginBottom: "2.5px" }}
                                    alt="Chipz icon"
                                />
                                50
                            </span>
                        </button>
                    </Container>
                )}

                {showSpinner && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-10px' }}>
                        <Spinner animation="border" variant="light" />
                    </div>
                )}
            </>
        ) : (
            <>
                <span className="container-body-text congratulations" style={{ color: "#00D1FF", marginLeft: '1rem' }}>Congratulations!</span>
                <span className="container-body-text bonezdeck" style={{ color: "white", marginLeft: '1rem' }}>NEW cards have been </span>
                <span className="container-body-text bonezdeck" style={{ color: "white", marginLeft: '1rem' }}>added to your Power Cards</span>

                <div className={showSpinner ? "backcards-spinner" : "backcards"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {showButtons && (<img className="shopback" alt="" src={cardImages(`./power-cards/${card1}.svg`)} style={{ marginLeft: '25%' }} />)}
                    {showSpinner && (
                        <div className="container-spinner-top" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner className="spinner" animation="border" variant="light" />
                        </div>
                    )}

                    {showButtons && (<img className="shopback" alt="" src={cardImages(`./power-cards/${card2}.svg`)} style={{ marginLeft: '10%' }} />)}
                    {showSpinner && (
                        <div className="container-spinner-top" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner className="spinner" animation="border" variant="light" />
                        </div>
                    )}
                </div>
                <div className={showSpinner ? "backcards2-spinner" : "backcards2"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {showButtons && (<img className="shopback" alt="" src={cardImages(`./power-cards/${card3}.svg`)} style={{ marginLeft: '10%' }} />)}
                    {showSpinner && (
                        <div className="container-spinner-bottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner className="spinner" animation="border" variant="light" />
                        </div>
                    )}

                    {showButtons && (<img className="shopback" alt="" src={cardImages(`./power-cards/${card4}.svg`)} style={{ marginLeft: '10%' }} />)}
                    {showSpinner && (
                        <div className="container-spinner-bottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner className="spinner" animation="border" variant="light" />
                        </div>
                    )}

                    {showButtons && (<img className="shopback" alt="" src={cardImages(`./power-cards/${card5}.svg`)} style={{ marginLeft: '10%' }} />)}
                    {showSpinner && (
                        <div className="container-spinner-bottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner className="spinner" animation="border" variant="light" />
                        </div>
                    )}
                </div>
                <span className="container-body-text another" style={{ color: "#00D1FF", marginLeft: '1rem', marginBottom: "10px", marginTop: "5%" }}>Get Another 5 Pack?</span>
                {showButtons && (
                    <Container style={{ display: "flex", justifyContent: "space-around" }}>
                        <button className="button" onClick={handleCoin} disabled={!showButtons} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                            <img className="green-button-10000" src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" />
                            <span className="button-text" style={{ fontSize: "22px", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px", textAlign: "center" }}>
                                <img
                                    className="icon"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    style={{ width: "40%", height: "90%", marginRight: "5px", marginBottom: "7%", marginLeft: "-20px" }}
                                    alt="Chipz icon"
                                />
                                10,000
                            </span>
                        </button>

                        <button className="button" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }} onClick={handleBonez} disabled={!showButtons}>
                            <img className="green-button-10000" src="https://zoombies.world/images/dapp/purple_button_500.webp" alt="" />
                            <span className="button-text" style={{ fontSize: "22px", marginLeft: "5px", textAlign: "center" }}>
                                <img
                                    className="icon"
                                    title="Zoombies Chipz"
                                    src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"
                                    style={{ width: "40%", height: "auto", marginRight: "5px", marginLeft: "-20px" }}
                                    alt="Chipz icon"
                                />
                                50
                            </span>
                        </button>
                    </Container>
                )}

                {showSpinner && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                        <Spinner animation="border" variant="light" />
                    </div>
                )}
            </>
        )
    );
}
